/**
 * @file Purchase PPD Individual Print Cart Item Container.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import get from 'lodash.get';

import {
  selectPrint as selectPrintAction,
  deselectPrint as deselectPrintAction,
} from '../../actions/ppd-purchase';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Button from '../../components/global/Button';
import TrashIcon from '../../components/icons/TrashIcon';
import { formatPriceForDisplay } from '../../util/format-money';
import PlusCircleIcon from '../../components/icons/PlusCircleIcon';
import StopIcon from '../../components/icons/StopIcon';
import Photo from '../../components/global/Photo';

class PurchasePpdIndividualPrintCartItemContainer extends Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      type: PropTypes.oneOf([PPD_CART_ITEM_TYPES.INDIVIDUAL_PRINT]),
      photo: PropTypes.shape({
        id: PropTypes.string,
      }),
      printSize: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
        price: PropTypes.shape({
          value: PropTypes.number,
        }),
      }),
      quantity: PropTypes.number,
    }),
    selectPrint: PropTypes.func,
    deselectPrint: PropTypes.func,
  };

  render() {
    const { cartItem, selectPrint, deselectPrint } = this.props;

    const printSize = get(cartItem, 'printSize');
    const { thumbnail_urls: thumbs } = cartItem.photo;
    const price = formatPriceForDisplay(get(printSize, 'price.value', 0));

    return (
      <div className="ppd-cart-item py-2 px-1">
        <div className="d-flex">
          <div className="cart-item-image">
            <Photo
              key={cartItem.photo.id}
              className="h-100"
              imgClassName="image-cover-img"
              thumbs={thumbs}
              blockCapture
              lowestQuality
            />
            <div className="cart-item-image-quantity">
              <span className="text-xs">QTY</span>
              <span className="text-lg">{cartItem.quantity}</span>
            </div>
          </div>
          <div className="cart-item-desc">
            <div className="d-flex justify-content-between">
              <p className="text-sm text-dark mb-0">
                {printSize.type.name} Print
              </p>
            </div>
            <div className="d-flex justify-content-between">
              <p className="text-sm text-bold text-dark mb-0">${price}</p>
              <div className="cart-item-actions">
                <Button
                  btnStyle="reset"
                  disabled={cartItem.quantity === 1}
                  onClick={() =>
                    selectPrint(
                      cartItem.photo,
                      cartItem.printSize,
                      // Avoid doing -1 or 0
                      Math.max(1, cartItem.quantity - 1),
                      cartItem.digitalDownloadUpsell,
                    )
                  }
                >
                  <StopIcon size="25" color="#0d84fe" />
                </Button>
                <Button
                  btnStyle="reset"
                  onClick={() =>
                    selectPrint(
                      cartItem.photo,
                      cartItem.printSize,
                      cartItem.quantity + 1,
                      cartItem.digitalDownloadUpsell,
                    )
                  }
                >
                  <PlusCircleIcon size="25" color="#0d84fe" />
                </Button>
                <Button
                  btnStyle="reset"
                  onClick={() =>
                    deselectPrint(cartItem.photo, cartItem.printSize)
                  }
                >
                  <TrashIcon size={23} color="#f1524b" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  selectPrint: (photo, printSize, quantity = 1) =>
    dispatch(selectPrintAction(photo, printSize, quantity)),
  deselectPrint: (photo, printSize) =>
    dispatch(deselectPrintAction(photo, printSize)),
});

export default compose(connect(null, mapDispatchToProps))(
  PurchasePpdIndividualPrintCartItemContainer,
);
